import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import BeatLoader from "react-spinners/BeatLoader";
import { collection, getDocs } from "@firebase/firestore";
import { db } from "../../firebase/firebase-config";
import ReportsModal from "../../components/ui/ReportsModal/ReportsModal";
import { Table, Input, Select } from 'antd';
import DataTable from "./DataTable/DataTable";

const { Search } = Input;

const rows: any = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    render: (text: any, record: any, index: number) => index + 1,
  },
  {
    title: "Slide Name",
    dataIndex: "slide_name",
    key: "slide_name",
    sorter: (a: any, b: any) => a.slide_name.localeCompare(b.slide_name),
  },
  {
    title: "Case Id",
    dataIndex: "case",
    key: "case",
    sorter: (a: any, b: any) => a.case.localeCompare(b.case),
  },
  {
    title: "Author",
    dataIndex: "owner",
    key: "owner",
    sorter: (a: any, b: any) => a.owner.localeCompare(b.owner),
  },
  {
    title: "CreatedAt",
    dataIndex: "created_at",
    key: "created_at",
    // sorter: (a: any, b: any) => a.created_at.localeCompare(b.created_at),
    render: (text: any) => {
      return <td className="">06/21/2023</td>

    }
  },
  {
    title: "Report",
    dataIndex: "file_url",
    key: "file_url",
    sorter: (a: any, b: any) => a.file_url.localeCompare(b.file_url),
    render: (file_url: any) => {
      return (
        <a href={file_url} rel="noreferrer" target="_blank">
          View Report
        </a>
      );
    }
  },
  // {
  //   label: "#",
  //   name: "num",
  // },
  // {
  //   label: "Slide Name",
  //   name: "name",
  // },
  // {
  //   label: "Case Id",
  //   name: "name",
  // },
  // {
  //   label: "Author",
  //   name: "name",
  // },
  // {
  //   label: "Created At",
  //   name: "name",
  // },
  // {
  //   label: "Report",
  //   name: "name",
  // },
];

const override = {
  marginTop: "20px",
};

function Index() {
  const [loading, setLoading] = useState(false);
  const [slideData, setSlideData] = useState([]);
  const [searchText, setSearchText] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any[]>(slideData);


  const [reportsModal, setShowReportsModal] = useState(false);

  const handleToggle = () => {
    setShowReportsModal(!reportsModal);
  }

  const fetchData = async () => {
    setLoading(true);
    const cases = await getDocs(collection(db, "Cases"));
    const res: any = [];

    cases.forEach((caseData) => {
      let temp: any = caseData.data();

      res.push({
        id: caseData.id,
        key: caseData.id,
        ...temp
      });

      setLoading(false);
    });

    // console.log(res);
    setSlideData(res);
  };

  useEffect(() => {
    fetchData();
  }, []);


  const [sortedInfo, setSortedInfo] = useState<any>({});

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    setSortedInfo(sorter);
  };

  slideData.forEach((item: any, index: any) => {
    item.index = index + 1;
  });

  useEffect(() => {
    // console.log('DATA: ####', slideData);
    const sortedData = slideData.sort((a:any, b: any) => {
      const cidNumberA = parseInt(a.CID.split('-')[1], 10);
      const cidNumberB = parseInt(b.CID.split('-')[1], 10);
      return cidNumberB.toString().padStart(5, '0').localeCompare(cidNumberA.toString().padStart(5, '0'));
    });
    setFilteredData(filterData(sortedData, searchText));
  }, [slideData, searchText]);

  const filterData = (data: any[], query: string) => {
    if (!query) return data;

    return data.filter((item) =>
      Object.values(item).some((value: any) =>
        value?.toString()?.toLowerCase()?.includes(query?.toLowerCase())
      )
    );
  };


  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  // console.log(slideData)


  return (
    <>
      <Layout title="Reports" pageTitle="Diagnosis">
        <div className="section">
          <div className="parent-con">
            <div className="data-table">
              <div className="top">
                <div className="span">
                  <h3>All Reports</h3>
                </div>

                <button onClick={handleToggle} className="btn btn-primary btn-add student-button">
                  {" "}
                  Add Report{" "}
                </button>
              </div>

              <div className="table-con">
                <div style={{ textAlign: "center" }}>
                  <BeatLoader
                    color="#3080ED"
                    loading={loading}
                    cssOverride={override}
                  />
                </div>
                <Search
                  placeholder="Search for data..."
                  onSearch={handleSearch}
                  onChange={(e) => handleSearch(e?.target?.value)}
                  value={searchText}
                  style={{ width: 200, marginBottom: 16 }}
                />

                <DataTable data={filteredData}/>

              </div>
            </div>
          </div>
        </div>
      </Layout>
      {reportsModal && <ReportsModal
        onContentAdded={handleToggle}
        onClose={handleToggle}
      />}
    </>
  );
}

export default Index;
